module.exports = __webpack_public_path__ + "img/23.faa516e7.svg";